import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { selectId, deselectId } from '../../../../actions/AsyncTable';

const EditSettingsVillageCheckbox = ({ id }) => {
    const dispatch = useDispatch();
    const selectedIds = useSelector(state => state.AsyncTable.selectedIds);
    const data = useSelector(state => state.AsyncTable.table.data);
    const currentStudent = data.find(item => item.id === id);
    const isChecked = selectedIds.some(student => student.id === id);

    const handleChange = event => {
        if (event.target.checked) {
            if (currentStudent) {
                dispatch(
                    selectId({
                        id: currentStudent.id,
                        last_name: currentStudent.last_name,
                        first_name: currentStudent.first_name,
                    })
                );
            }
        } else {
            dispatch(deselectId(id));
        }
    };

    return <Checkbox checked={isChecked} onChange={handleChange} inputProps={{ 'data-id': id }} color="success" />;
};

export default EditSettingsVillageCheckbox;
